import React, { useState } from 'react';

import * as S from './Faqs.styles';

const Faqs = ({ heading, faqData,tncHeading,tncData }) => {
  const [active, setActive] = useState(0);

  const handleFaqs = (idx) => {
    setActive(active === idx ? null : idx);
  }

  return (
    <S.FaqsCont>
      {heading && <S.FaqsHeading>{heading}</S.FaqsHeading>}
      {
        faqData && faqData.length > 0 &&
        faqData.map(({ id, question, answerList }, index) => (
          <S.FaqsRow key={id}>
            <S.FaqsQuestion isActive={active === index} onClick={() => handleFaqs(index)}>{question}</S.FaqsQuestion>
            {
              active === index &&
              <S.FaqsList>
                {
                  answerList.map((item, index) => (
                    <li key={index} style={{whiteSpace: "pre-line"}}>{item}</li>
                  ))
                }
              </S.FaqsList>
            }
          </S.FaqsRow>
        ))
      }
      {tncHeading && <S.FaqsHeading style={{margin: '60px 0 0 0', borderBottom: 'none'}}>{tncHeading}</S.FaqsHeading>}
      {
        tncData && tncData.length > 0 &&
          <S.FaqsList>
            {
              tncData.map((item, index) => (
                <li key={index} style={{whiteSpace: "pre-line"}}>{item}</li>
              ))
            }
          </S.FaqsList>
      }
    </S.FaqsCont>
  )
}

export default Faqs;